export class InvoiceDetailRejectedReasonListPresenter {
  constructor(result) {
    return result.map(value => {
      return {
        id: value.id,
        message: value.message,
      };
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/other-web/supplier/presenters/InvoiceDetailRejectedReasonListPresenter.js